import { render, staticRenderFns } from "./OrganizationNotification.vue?vue&type=template&id=2cbdf5f8&"
import script from "./OrganizationNotification.vue?vue&type=script&lang=js&"
export * from "./OrganizationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports